import { useContext, useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import mixpanel from 'mixpanel-browser';
import { Context } from '../Store';
import UserService, { UserStatus } from '../services/UserService';
import types from '../Reducer/types';

export default function useDriverProfile(api, pathname) {
  const { dispatch } = useContext(Context);
  const { logout } = useAuth0();
  const [user, setUser] = useState(null);

  useEffect(() => {
    let active = true;
    async function refreshUser() {
      const nextUser = await UserService.getUser();
      if (!active) return;
      setUser(nextUser);
      dispatch({ type: types.SET_USER, payload: nextUser });
      mixpanel.identify(nextUser.id);
      if (nextUser.status !== UserStatus.ACTIVE) {
        logout();
      }
    }

    if (api) {
      UserService.init(api);
      refreshUser().catch((error) => {
        if (active) console.error('Unable to load driver profile', error);
      });
    }
    return () => { active = false; };
  }, [api, pathname, dispatch, logout]);

  return user;
}
